// extracted by mini-css-extract-plugin
module.exports = {"comp":"K_comp__RfrUX"};